import { createContext, useContext, useEffect, useState } from "react";
import { fetchAuthSession } from 'aws-amplify/auth';

// Create the context
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const loadSession = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.accessToken?.toString() || null;
      setAccessToken(token);
      setIsAuthenticated(!!token);
      console.log("Access token", token);
    } catch (err) {
      console.error("Failed to fetch auth session", err);
      setError(err);
      setAccessToken(null);
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadSession();
  }, []);

  return (
    <AuthContext.Provider 
      value={{
        accessToken,
        isLoading,
        error,
        isAuthenticated,
        refreshSession: loadSession
        }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};